app.controller('BrowseCommonHingeHoleController', ['$scope', '$rootScope', function ($scope, $rootScope) {
    $rootScope.is_collapsed = true;

    $scope.is_timber = $scope.navigation_values.site_range_is_timber

    $scope.product = $scope.partial_product;
    $scope.show_atc = true;

    $scope.hinge_hole_sides = [];

    $scope.applyProduct = function (partialProduct, partialStyle) {
        const doUpdate = partialProduct !== $scope.product;
        $scope.product = partialProduct;
        $scope.partial_style = partialStyle;
        if (partialStyle === 'collection') {
            $scope.show_atc = false;
        }
        if (doUpdate) {
            applyHingeHoleSides();
        }
    }


    function applyHingeHoleSides() {
        if ($scope.product && $scope.product.hinge_hole_options && $scope.product.hinge_hole_options.length > 0) {
            $scope.hinge_hole_sides = $scope.product.hinge_hole_options;
            $scope.product.drillside = $scope.hinge_hole_sides[0].value;
        } else {
            $scope.hinge_hole_sides = [
                {value: "", name: "-- None --"},
                {value: "left", name: "Left"},
                {value: "right", name: "Right"},
                {value: "left_and_right", name: "Drill Both Sides"},
                {value: "top", name: "Top Hung"},
                {value: "bottom", name: "Bottom Hung"}
            ]
        }
    }

    applyHingeHoleSides();

}]);